<template>
  <div class="financial_content">
    <div class="financial">
      <div class="financial_box" v-for="board in boardData" :key="`financial${board.wr_id}`"
           @click="goDetail(board.wr_id)">
        <img class="financial_box_img" :src="returnImage(board)">
        <div class="financial_box_title">{{ board.wr_subject }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";

export default {
  name: "BoardListFinancialLayout",
  mixins: [imageOption],
  components: {},
  inject: [],
  provide() {
    return {}
  },
  props: {
    boardData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    returnImage(board) {
      if (!util.isEmpty(board.File.MobileFile[0])) {
        return `${board.File.MobileFile[0].org_url}?${this.setImageOptions(316, 316, 'jpg')}`;
      }
    },
    goDetail(idx) {
      this.$router.push(`/financial/${idx}`)
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>